import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom"; // Correct imports
import axios from "axios";
import "./loginregister.css";
import Image1 from "../../assets/images/login_page_img_two.png";
import { toast } from "react-toastify";
import { apiurl } from "../../Constants";
function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    try {
      const response = await axios.post(apiurl + "reset", {
        email,
        password,
        token,
      });

      if (response.status === 200) {
        toast.success("Password successfully reset!");
        navigate("/login");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      alert("Failed to reset password. Please try again.");
    }
  };

  return (
    <section className="loginregister_section pt-40 pb-40">
      <div className="container">
        <div className="row">
          <div className="login-page-padding col-lg-6 col-md-6 col-sm-12">
            <div className="img_inner_box">
              <img src={Image1} alt="img" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 right_col">
            <div className="form_inner_box">
              <h2 className="text-center">Reset Password</h2>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label mb-2">
                    New Password <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="password"
                    placeholder="New Password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label mb-2">
                    Confirm Password <sup className="mandatory_symbol">*</sup>
                  </label>
                  <input
                    type="password"
                    placeholder="Confirm Password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3 text-center">
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  <button className="btn_1_1" type="submit">
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgotPassword;
